<template>
  <div :class="[{ disabled }, 'colorfule-selects']">
    <template v-if="readonly">
      <el-input
        v-model="labelText"
        type="text"
        placeholder
        required="required"
        :readonly="true"
      />
    </template>
    <template v-else>
      <el-select
        :value="value"
        :disabled="disabled"
        :multiple="multiple"
        :clearable="clearable"
        :filterable="filterable"
        :collapse-tags="collapseTags"
        :placeholder="filterPlaceholder"
        :popper-append-to-body="popperAppendToBody"
        :popper-class="PopperClass"
        @blur="onSelectBlurEvent"
        @change="onChangeSelect"
        @input="$emit('input', $event)"
      >
        <slot>
          <template v-for="(it, idx) in filterNullData">
            <el-option
              :key="it.label + idx"
              :value="it.value"
              :label="it.label"
            />
          </template>
        </slot>
      </el-select>
    </template>

    <svg-icon
      v-if="!readonly"
      :icon-class="opSvg ? 'arrow' : 'dropdown'"
      class="right-icon"
    />
  </div>
</template>

<script>
export default {
  name: 'common-select',
  props: {
    value: {
      type: [String, Number, Array],
      comment: 'v-model使用的数据'
    },
    disabled: {
      type: Boolean,
      default: false,
      comment: '是否禁用'
    },
    clearable: {
      type: Boolean,
      default: false,
      comment: '是否可以一键清除'
    },
    filterable: {
      type: Boolean,
      default: false,
      comment: '是否启用本地搜索'
    },
    placeholder: {
      type: String,
      default: '请选择',
      comment: '占位文字'
    },
    radius: {
      type: Number,
      default: 0,
      comment: '图标圆角'
    },
    collapseTags: {
      type: Boolean,
      default: false,
      comment: '是否合并为一段文字'
    },
    multiple: {
      type: Boolean,
      default: false,
      comment: '是否开启多选'
    },
    readonly: {
      type: Boolean,
      default: false,
      comment: '是否隐藏箭头'
    },
    filterNull: {
      type: Boolean,
      default: false,
      comment: '是否去掉value为空的属性' // 用于不显示{value:'';label:'全部'}
    },
    offset: {
      type: Object,
      default() {
        return {}
      },
      comment: '自定义的样式'
    },
    list: {
      type: [Array, Object],
      default() {
        return []
      },
      comment: '要匹配的下拉'
    },
    opSvg: {
      type: Boolean,
      default: false,
      comment: '是否把img切换为svg'
    },
    popperAppendToBody: {
      type: Boolean,
      default: true,
      comment: ''
    },
    PopperClass: {
      type: String,
      default: '',
      comment: 'select class'
    }
  },

  data() {
    return {
      selectVal: null
    }
  },
  computed: {
    labelText() {
      return this.getLabel()
    },
    // 过滤空数据
    filterNullData() {
      if (this.filterNull) {
        return this.list.filter(item => item.value)
      } else {
        return this.list
      }
    },
    filterPlaceholder() {
      return this.disabled || this.readonly ? '' : this.placeholder
    }
  },

  methods: {
    // 获取label
    // 匹配的对象 例 ：[{value:"1",label:"是"}]   Array
    getLabel() {
      if (this.list.length) {
        let label = this.list.filter(it => {
          if (String(it.value) === String(this.value)) {
            return it.label
          }
        })
        return label.length ? label[0].label : ''
      } else {
        return ''
      }
    },
    onSelectBlurEvent(event) {
      this.$emit('blur', event)
    },
    onChangeSelect(currentVal) {
      // console.log(currentVal, 'aaaaaa')
      this.$emit('input', currentVal)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';

.svg-arrow {
  position: absolute;
  top: calc(50% - 9px);
  left: calc(100% - 21px);
  font-size: 20px;
}
</style>
